import { useLingui } from "@lingui/react/macro";
import { DailyOverviewFilterInput } from "./DailyOverviewContextComponents";

export const DailyOverviewPatientNameFilterInput = () => {
  const { t } = useLingui();
  return <DailyOverviewFilterInput label={t`Sök patient`} />;
};
